/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/DUCATI.glb 
*/
import React, { useRef, useState, useEffect } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { easing } from 'maath'
import { TextureLoader, MeshStandardMaterial, RepeatWrapping, MeshPhysicalMaterial, Color } from 'three';
import { cameraViewMatrix } from 'three/examples/jsm/nodes/Nodes.js';

export function Yacht_Floor({color7, ...props}) {
  const { nodes, materials } = useGLTF('/yacht-base.glb')
  const ref = useRef()
  const textureS = useTexture('/wood.avif'); // Ścieżka do twojego pliku JPG
  
  // Ustawienie powtarzania tekstury
  textureS.wrapS = RepeatWrapping;
  textureS.wrapT = RepeatWrapping;
  textureS.repeat.set(1, 1);

  const textureS2 = useTexture('/wood.avif'); // Ścieżka do twojego pliku JPG
  
  // Ustawienie powtarzania tekstury
  textureS2.wrapS = RepeatWrapping;
  textureS2.wrapT = RepeatWrapping;
  textureS2.repeat.set(1, 1);

  const [currentColor, setCurrentColor] = useState(new Color(color7));

  let textColor;

  if ((color7 === 'F1F0EA') || (color7 === '#0E0E10')) {
    textColor = null 
  } else if (color7 === '#9e7c59') {
    textColor = textureS
  } else if (color7 === '#331a00') {
    textColor = textureS2
  }


  const paint = new MeshStandardMaterial({
    map: textColor,
    color: currentColor,
    roughness: 1,
    metalness: 0.25,
  });

  useFrame((state, delta) => {
    const targetColor = new Color(color7);
    easing.dampC(currentColor, targetColor, 0.1, delta);
    setCurrentColor(currentColor.clone()); // Update state to trigger re-render
    if (ref.current) {
      ref.current.material.color.set(currentColor); // Update the material color directly
    }
  });
  
  return (
    <group {...props} dispose={null} scale={10}>
      <mesh castShadow receiveShadow casrt ref={ref} geometry={nodes.floor.geometry} material={paint} material-rougness={0}/>
    </group>
  )
}

useGLTF.preload('/DUCATI.glb')

